
import { Component, Emit, Prop, Mixins } from 'vue-property-decorator'
import CircleGroup from './views/circleGroup/index.vue'
import { OrderDetails } from '@xt/client/mixins'
import { Observer } from 'mobx-vue'
import ViewDescItem from './views/item.vue'
import OrderProduct from '@xt/www/pages/my/children/views/Product/index.vue'
import Product from '@xt/client/entities/basics/product'
import { EnumCouponTimeRule } from '@xt/client/utils/coupon'
import CouponItem from '../coupon/CouponItem.vue'
import GiftCouponPop from '../coupon/CouponUseInfo.vue'

@Observer
@Component({
  components: {
    CircleGroup,
    ViewDescItem,
    OrderProduct,
    CouponItem,
    GiftCouponPop
  }
})
export default class OrderDesc extends Mixins(OrderDetails) {
  @Prop() title: string
  @Prop({}) visible: boolean
  @Prop({}) orderNum: string
  @Prop() productInfo: Product
  @Prop() showRefundTime: boolean
  @Prop() refundStatus: boolean
  @Prop() refundEndDate: number
  @Prop() orderStatus: string
  @Prop() orderStatusStyle: string
  @Prop() virtualCurrency: number
  @Prop() getCoinPayPrice: number
  @Prop() payAmounts: number
  @Prop() showInvoiceIng: boolean
  @Prop() showInvoiceSuccess: boolean

  get EnumCouponTimeRule() {
    return EnumCouponTimeRule
  }

  addMousedownHandler(name: string) {
    const xt = document.querySelector('#__xt')

    const a = xt && xt.querySelector(`.${name}`)

    a?.addEventListener('mousedown', this.stopHandler)
  }

  removeMousedownHandler(name: string) {
    const xt = document.querySelector('#__xt')

    const a = xt && xt.querySelector(`.${name}`)

    a?.removeEventListener('mousedown', this.stopHandler)
  }

  couponDescPopOpen() {
    this.addMousedownHandler('coupon-desc-popup-container')
  }

  couponDescPopClosed() {
    this.removeMousedownHandler('coupon-desc-popup-container')
  }

  couponDescPopClose() {
    this.visibleCouponDesc = false
  }

  @Emit('opened')
  onOpened() {
    this.addMousedownHandler('modal-container')
  }

  @Emit('closed')
  onClosed() {
    this.removeMousedownHandler('modal-container')
  }

  @Emit('close')
  onClose() {}

  stopHandler(e: MouseEvent) {
    e.stopPropagation()
  }

  clickUseDescHandler(data: any) {
    this.couponDescInfo = data
    this.visibleCouponDesc = true
  }

  async created() {
    const store = this.$store.$storeOrder.orderDetail
    await store.onLoading({ orderNo: this.orderNum })
    const resp = await this.$store.$coupon.assocOrder.onGetCouponListByOrderNo(this.orderNum)
    if (Array.isArray(resp)) {
      this.orderAssocCouponList = resp
    }
    this.dataSource = this.Detail.dataSource
  }

  destroyed() {}
}
